
import { Layout } from "@/components/Layout/Layout";

export default function Cookies() {
  return (
    <Layout>
      <div className="container max-w-4xl py-12 px-4 mx-auto animate-fade-in">
        <h1 className="text-3xl font-bold mb-6">Cookie Policy</h1>
        
        <div className="prose prose-sm sm:prose max-w-none">
          <p className="lead">This Cookie Policy explains how ThePromptSpace uses cookies and similar technologies to recognize you when you visit our platform.</p>
          
          <h2>1. What are Cookies?</h2>
          <p>Cookies are small data files that are placed on your device when you visit a website. Cookies are widely used by website owners to make their websites work efficiently and provide analytical information.</p>
          
          <h2>2. Types of Cookies We Use</h2>
          
          <h3>Essential Cookies</h3>
          <p>These cookies are necessary for the platform to function properly. They enable core functionality such as security, network management, and account access. You cannot opt out of these cookies.</p>
          
          <h3>Performance and Analytics Cookies</h3>
          <p>These cookies help us understand how visitors interact with our platform by collecting and reporting information anonymously. They help us measure and improve the performance of our platform.</p>
          
          <h3>Functionality Cookies</h3>
          <p>These cookies enable enhanced functionality and personalization, such as remembering your preferences and settings. They may be set by us or by third-party providers whose services we have added to our platform.</p>
          
          <h3>Targeting and Advertising Cookies</h3>
          <p>These cookies are used to deliver relevant advertisements and track the efficiency of advertising campaigns. They remember that you have visited our platform and may share this information with other organizations, such as advertisers.</p>
          
          <h2>3. Third-Party Cookies</h2>
          <p>Some cookies are placed by third parties on our behalf. These third parties may include analytics providers, advertising networks, and social media platforms. These third parties may use cookies, web beacons, and similar technologies to collect information about your use of our platform and other websites.</p>
          
          <h2>4. How to Manage Cookies</h2>
          <p>Most web browsers allow you to control cookies through their settings preferences. However, if you limit the ability of websites to set cookies, you may worsen your overall user experience and/or lose access to certain features.</p>
          
          <h3>Browser Settings</h3>
          <p>You can manage cookies through your browser settings. Please refer to your browser's help section for instructions on how to manage cookies.</p>
          
          <h3>Our Cookie Preferences Tool</h3>
          <p>We provide a cookie preferences tool that allows you to choose which types of cookies you accept or reject, with the exception of essential cookies which are necessary for the platform to function properly.</p>
          
          <h2>5. Changes to This Cookie Policy</h2>
          <p>We may update this Cookie Policy from time to time. We will notify you of any changes by posting the new Cookie Policy on this page and updating the "Last updated" date.</p>
          
          <h2>6. Contact Us</h2>
          <p>If you have any questions about this Cookie Policy, please contact us at privacy@thepromptspace.com.</p>
          
          <p className="text-sm text-muted-foreground mt-8">Last updated: April 4, 2025</p>
        </div>
      </div>
    </Layout>
  );
}
